import { render, staticRenderFns } from "./PeriodoReutilizable.vue?vue&type=template&id=353de482"
import script from "./PeriodoReutilizable.vue?vue&type=script&lang=js"
export * from "./PeriodoReutilizable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports